import { ChevronRightIcon } from '@heroicons/react/24/outline';

export const BreadcrumbSeparator = () => {
  return <ChevronRightIcon className="size-4 text-gray-400" />;
};
